import React, { useState, useEffect } from 'react';
import Activo from '../../components/activo/Activo';
import './modalSus.css'
import { useTranslation } from 'react-i18next';
const Modal = ({ isOpen, closeModal }) => {

    const [inputNombre, setInputNombre] = useState('');
    const [inputApellido, setInputApellido] = useState('');
    const [inputCorreo, setInputCorreo] = useState('');
    const [t, i18n] = useTranslation("global");
    const [isValidEmail, setIsValidEmail] = useState(true);

    const handleEmailChange = (event) => {
        const { value } = event.target;
        setInputCorreo(value);
    
        // Validar el formato del correo electrónico
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        setIsValidEmail(emailRegex.test(value));
      };
      
    useEffect(() => {

        setInputNombre('');
        setInputApellido('');
        setInputCorreo('');

    }, []);

    if (!isOpen) return null;


    return (
        <div  className='modal_p_sus' >
            <div className='modal_sus'>


                <div className='suscribir'>


                    <div className="contenedor_suscribir">



                        <div class="row4_LB">

                            <div class="row4_LB">
                                <div class="preg">
                                    <div class="mb-3">
                                        <input id="name" class="input-form input-value input_dat" placeholder={(t('forms.name'))} name="fromName" value={inputNombre} onChange={(e) => setInputNombre(e.target.value)} required/>
                                    </div>
                                    <div class="mb-3">
                                    </div>
                                    <hr class="linea_suscri"></hr>
                                    <div class="mb-3">
                                        <input id="apellido" class="input-form input-value input_dat" placeholder={(t('forms.last_name'))} name="from" value={inputApellido} onChange={(e) => setInputApellido(e.target.value)} />
                                    </div>
                                    <hr class="linea_suscri"></hr>
                                    <div class="mb-3">
                                        <input id="email" class="input-form input-value input_dat" placeholder={(t('forms.email'))} type="email" name="email" value={inputCorreo} onChange={handleEmailChange} required/>
                                    </div>
                                    <hr class="linea_suscri"></hr>
                                    <br />
                                </div>
                            </div>
                        </div>

                        <div>
                            <Activo nombre={inputNombre} apellido={inputApellido} correo={inputCorreo} valid={isValidEmail} closeModal={closeModal} />
                           
                        </div>

                    </div>
                </div>

                <button className="botonPop" onClick={closeModal}>
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div className="background_gri"></div>
        </div>
    );

};

export default Modal;